import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";

const OrderHistoryPage = () => {
  return (
    <div>
      <Footer />
    </div>
  );
};

export default OrderHistoryPage;
